import { priceLabelStylingType, PriceLabelStyleType } from './types';

export const getPriceLabelStyling = (
  isCampaign: boolean,
  storeIsFeatured?: boolean | null
): priceLabelStylingType => {
  if (!storeIsFeatured) return PriceLabelStyleType.LIGHTEN;
  if (isCampaign) return PriceLabelStyleType.CAMPAIGN;
  return PriceLabelStyleType.PRIMARY;
};
